import { Component, ViewChild, ViewContainerRef } from '@angular/core'
import { LoadingService } from './services/common/loading.service'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { start_initializing } from './store/action/initialize.action'
import { AppState } from './store/state/app.state'
import { initialInitializeState } from './store/state/initial.state'
import * as AOS from 'aos'
import { DynamicComponentLoaderService } from './services/dynamic-component-loader/dynamic-component-loader.service'
import { AuthService } from './services/auth/auth.service'
import { GlobalConstants } from './constants/global-constants'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  @ViewChild('targetContainer', { read: ViewContainerRef }) targetContainer: ViewContainerRef

  loading$ = this.loader.loading$

  title = 'sop-admin-portal'

  constructor(
    public loader: LoadingService,
    private authService: AuthService,
    private appState: Store<AppState>,
    private router: Router,
    private dynamicComponentLoaderService: DynamicComponentLoaderService
  ) {}

  ngOnInit(): void {
    AOS.init()
    if (this.authService.isUserAuthenticated()) {
      this.appState
        .select(state => state.initialize)
        .subscribe(data => {
          if (data === initialInitializeState) {
            this.appState.dispatch(start_initializing({ comingFromLogin: false }))
          }
        })
    }
  }

  isPanelEnabled(): boolean {
    const path = this.router.url.split('?')[0]

    return !(path === '/' || path === '/login' || path.startsWith('/login/'))
  }

  ngAfterViewInit(): void {
    this.dynamicComponentLoaderService.registerComponent(
      GlobalConstants.DYNAMIC_MODEL.CLIENT_SELECTOR.key,
      this.targetContainer,
      GlobalConstants.DYNAMIC_MODEL.CLIENT_SELECTOR.component
    )
    this.dynamicComponentLoaderService.registerComponent(
      GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.key,
      this.targetContainer,
      GlobalConstants.DYNAMIC_MODEL.RESET_PASSWORD.component
    )
  }
}
